<template>
  <div class="my-1">
    <form action="#" class="search-form bg-white">
      <div class="control">
        <input type="text" class="input" @blur="open = false" @focus="open = true" :placeholder="placeholder" id="search-in-acc" v-model="needle"
          autocomplete="off" />
        <button type="button" class="btn-search" @click="onClear" :style="{pointerEvents: needle ? 'auto' :'none', cursor: 'pointer'}">
          <template v-if="needle">
            <i class="icon icon-close"></i>
            <span class="is-sr-only">Close</span>
          </template>
          <template v-else>
            <i class="icon icon-search-thick"></i>
          </template>
        </button>
      </div>
      <ul class="search-form-dropdown" v-if="open">
        <li v-for="(item, index) in items" :key="`option-${item.abreviatura}-${index}`" role="button"
          @mousedown="onSelectOption(item)">
          {{ item.name }}
        </li>
        <li v-if="needle && items.length == 0" :style="{pointerEvents: 'none'}">
          State page not found
        </li>
      </ul>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "VStateLookup",
  props: {
    urlEndPoint: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: "Type your ZIP or state"
    }
  },
  data() {
    return {
      needle: "",
      options: [],
      open: false
    };
  },
  computed: {
    items() {
      return this.options.filter(({ name, codes }) => {
        const state = name.toLowerCase();
        let value = this.needle || '';
        value = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const reg = new RegExp(`\\b${value}\\d*`, 'g');
        let code = codes.join(", ");
        code = code.match(reg);        
        code = code ? code.join("").replace(/\D/gi, '').length : false;        

        return value && (code || state.includes(value.toLowerCase()))
      });
    }
  },
  async mounted() {
    this.options = await axios(this.urlEndPoint).then(res => res.data).catch((e) => {
      console.error(e.data)
      return []
    });
  },
  methods: {
    onSelectOption(item) {
      this.checkEndpoint(item.url)
    },
    onClear(e) {
      e.preventDefault();
      this.needle = "";
    },
    onSend(e) {
      e.preventDefault();
      this.checkEndpoint(this.items[0].url);
    },
    async checkEndpoint(url) {
      window.location.href = url;
    }
  },
};
</script>
